import React, { Component } from 'react';
import './dropdown.scss';

class NewDropdown extends Component {
  renderOptions() {
    if (this.props.options) {
      let opts = this.props.options;
      if (opts.length && typeof opts[0] !== 'object') {
        opts = this.props.options.map((option) => ({ value: option, label: option }));
      }
      return opts.map((opt) => (
        <option value={opt.value} disabled={opt.disabled} key={opt.value}>
          {opt.label}
        </option>
      ));
    }
  }

  render() {
    const { id, label, value, disabled, className } = this.props;
    return (
      <div className={className}>
        {label ? <p className="panel-label">{label}</p> : undefined}
        <select id={id} value={value} onChange={(e) => this.props.onChange(e.target.value)} disabled={disabled}>
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}

export default NewDropdown;
